export enum PrivacyPolicyUrl {
  'en-US' = 'https://www.idealsvdr.com/privacy/',
  'zh-CN' = 'https://www.idealsvdr.cn/privacy/',
  'pt-BR' = 'https://pt.idealsvdr.com/politica-de-privacidade/'
}
